{
  "auth": {
    "listItem1": "For us at Oldcastle Infrastructure, safety is a core value. Our goal is to achieve ZERO HARM at our sites to ensure all individuals go home in the same condition in which they arrived. We protect each other, look out for one another, and when we see something, we stop and do something.",
    "listItem2": "We strongly encourage everyone to take time and make safety a part of their lifestyle no matter the environment.",
    "subtitle": "At Oldcastle, we put safety first.",
    "title": "Online Contractor Orientation"
  },
  "contractor": {
    "dashboard": {
      "title": "Online Contractor Orientation {year}",
      "accessMessage": "Complete the Online Contractor Orientation {year} to gain access to its sites across the United States.",
      "bulletPoints": [
        "You’ll be able to choose the site you want to access at the end of the process.",
        "After submitting the orientation, you’ll receive a certificate you can show a site manager to enter."
      ],
      "completedTitle": "Your Online Contractor Orientation has been completed for {year}!",
      "assignedSites": "You are assigned to the following site{plural}.",
      "certificateSent": "Certificate has been sent!",
      "certificateResend": "Resend certificate",
      "explore": "Explore Oldcastle products and lines",
      "learn": "Know more about Oldcastle and its values",
      "addToSite": "Add me to a site"
    },
    "label": "Contractor",
    "list": "List of Contractors",
    "search_placeholder": "Type the name of a contractor or company..."
  },
  "orientation": {
    "title": "Online Contractor Orientation",
    "preface": {
      "title": "Preface",
      "content": "<p>Keep in mind that this orientation will be <b>graded at the end</b>. You have to read the orientation carefully and understand its content.</p><p>If you don't pass with the minimum grade accepted by Oldcastle, you will be asked to retake the test until you do.</p>"
    },
    "testButton": "Test your knowledge",
    "quiz": {
      "title": "Final Comprehension Test",
      "gradingTitle": "Grading Process",
      "gradingContent": "<p class='mb-15'>This comprehension test is graded. If you don’t have a final grade of<strong> at least {passing} %</strong> or if you don’t get <strong>{goodAnswersRequired} questions out of {totalQuestions}</strong> right, you’ll have to retake the test.</p><p>If you pass, you’ll be able to select the site you want to link to your certificate and, then, be able to visit this specific OI site.</p>",
      "start": "Take the test",
      "question": "Question",
      "true": "True",
      "false": "False",
      "right": "Right answer!",
      "wrong": "Wrong answer!",
      "submit": "Submit my answer",
      "next": "Next question",
      "finish": "Submit the test",
      "grade": "Grade : {grade} %",
      "failed": "<p class=\"quiz-fail__text mb-15\">Unfortunately, you didn’t pass the test. You missed <strong>{missed} questions</strong>. In order to get your certificate you must have a score of at least {passing}%. Please redo the test.</p><p class=\"quiz-fail__text\">Also, do not click on \"Cancel\" before passing the test and confirming your linked site. If you do, you will lose all your progress.</p>",
      "retake": "Restart the orientation"
    },
    "passed": {
      "congrats": "Congrats! You have successfully completed the Online Contractor Orientation!",
      "email": "Your certificate has been emailed to you. Please provide it to your contact once you arrive on site.",
      "chooseSite": "The last step is to choose which site you want to access. You’ll be able to edit it until you complete the on-site induction.",
      "successSite": "You have successfully chosen the following as your site.",
      "editSite": "You’ll be able to edit it until you complete the on-site induction.",
      "chooseSiteBtn": "Choose this site",
      "backHome": "Return to home"
    }
  },
  "reports": {
    "allCompaniesByYear": {
      "subtitle": "that have contractors",
      "title": "All Companies"
    },
    "allContractorsBySite": {
      "subtitle": "for all sites or by specific site",
      "title": "All Contractors"
    },
    "allContractorsInfo": {
      "subtitle": "with info",
      "title": "All Contractors"
    },
    "allSites": {
      "subtitle": "with site managers",
      "title": "All Sites"
    }
  },
  "quick_actions": {
    "company:add": {
      "text": "Add a company so that contractors can identify themselves during sign up.",
      "title": "Add a company"
    },
    "site:add": {
      "text": "Add a site to start business there.",
      "title": "Add a site"
    },
    "site-manager:add": {
      "text": "Add a manager to a blank site, replace an existing manager or create a new manager.",
      "title": "Add a site manager"
    },
    "title": "Quick Actions"
  },
  "address": "Address",
  "add_company_info": "Add company info",
  "add_contractor": "Add a contractor",
  "add_cover_image": "Add cover image",
  "add_existing_manager": "Add existing manager",
  "add_manager": "Add manager",
  "add_new_manager": "Add new manager",
  "add_site_info": "Add site info",
  "add_site_manager": "Add a site manager",
  "all_contractors_with_info_linked_to_selected_site": "All contractors with info linked to selected site",
  "all_sites": "All Sites",
  "back_to_dashboard": "Back to dashboard",
  "cancel": "Cancel",
  "choose_existing_manager": "Choose an existing manager",
  "choose_site_to_link": "Choose a site to link",
  "close_window": "Close window",
  "companies": "Companies",
  "companies_profile": "Company Profile",
  "company": "Company",
  "company_been_added": "Has been added as a company. Its info can be edited at any time in its profile.",
  "company_name": "Company Name",
  "complete": "Complete",
  "confirm": "Confirm",
  "confirmation_email_sent": "A confirmation email has been sent to the user. It will be possible to see their profile once the email is verified and the user has created their account.",
  "contractor_has_no_site": "This contractor has no assigned site yet.",
  "contractor_has_not_completed_inductions_that_year": "This contractor has not completed any inductions that year.",
  "contractor_has_not_completed_inductions_this_year": "This contractor has not completed any inductions this year.",
  "contractor_has_not_done_inductions_yet": "This contractor has not done any inductions yet.",
  "contractor_name": "Contractor Name",
  "contractors": "Contractors",
  "contractors_profile": "Contractor Profile",
  "create_a_report": "Create a report",
  "create_new_manager": "Create new manager",
  "create_new_section": "Create new section",
  "current_status": "Current Status",
  "date_of_completion_online_orientation": "Date of Completion - Online Orientation",
  "date_of_birth": "Date of Birth",
  "display_info_from_site": "Display info from a specific site",
  "done": "Done",
  "edit_cover_image": "Edit cover image",
  "edit_the_orientation": "Edit the orientation",
  "email": "Email",
  "errors": {
    "media_upload": "Media failed to upload."
  },
  "final_comprehension_test": "Final Comprehension Test",
  "first_name": "First Name",
  "forgot_password": "Forgot Password?",
  "incomplete": "Incomplete",
  "induction_complete_confirmation": "Are you sure you want to make the following On-Site Induction",
  "induction_completed_on": "Induction completed on",
  "last_name": "Last Name",
  "loading": "Loading...",
  "logout_success": "Logged out successfully.",
  "manager": "Manager",
  "manager_detach_confirmation": "Are you sure you want to remove this manager from this site? The action won't delete their profile.",
  "name": "Name",
  "new_password": "New Password",
  "next": "Next",
  "next_question": "Next question",
  "no_manager_history_for_year": "This site doesn't have a manager history for this year.",
  "no_notifications": "No notifications.",
  "notifications": "Notifications",
  "now_manager_of": "is now a manager of",
  "orientation_published_successfully": "Orientation published successfully.",
  "on-site_training": "On-Site Training",
  "on-site_training_status": "On-Site Training Status",
  "password": "Password",
  "password_changed": "The password was successfully changed.",
  "previous": "Previous",
  "previous_question": "Previous question",
  "profile": "Profile",
  "publish_orientation": "Publish Orientation",
  "remember_me": "Remember me",
  "resend": "Resend",
  "reset": "Reset",
  "reset_password": "Reset Password",
  "reset_password_email_sent": " An email was successfully sent to <strong>{email}</strong> to reset the password.",
  "results_in": "Results in",
  "review_choice": "Review the choice",
  "review_company_info": "Review company info",
  "review_site_info": "Review site info",
  "save": "Save",
  "save_changes": "Save changes",
  "saving": "Saving...",
  "search": "Search",
  "search_something": "Search something...",
  "section": "section",
  "see_company_profile": "See company profile",
  "see_manager_profile": "See manager profile",
  "see_more": "See more",
  "see_previous_notifications": "See previous notifications",
  "see_site_profile": "See site profile",
  "send": "Send",
  "session_expired": "Your session has expired.",
  "sign_in": "Sign In",
  "sign_in_success": "Signed in successfully.",
  "sign_up": "Sign Up",
  "sign_up_email_sent": "A validation email was sent to your inbox. Please click the link in the email to confirm.",
  "sign_up_success": "You successfully signed up!",
  "site": "Site",
  "sites": "Sites",
  "sites_profile": "Site Profile",
  "site_been_added": "Has been added as a site. Eventually, a site manager has to be linked to it.",
  "site_doesnt_have_managers": "This site does not have a site manager yet.",
  "site_has_managers": "This site already has one or several managers. You can manage their role below or in the site’s profile.",
  "site_history": "Site History",
  "site_manager_history": "Site Manager History",
  "site_manager_name": "Site Manager Name",
  "site-managers": "Site Managers",
  "site-managers_profile": "Site Manager Profile",
  "site_name": "Site Name",
  "site_names": "Site Names",
  "site_status_history": "Site Status History",
  "start": "Start",
  "switch_current_site": "Switch Current Site",
  "to_do": "To Do",
  "to_selected_site": "To selected site",
  "year": "Year"
}
